import React, { useEffect } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import About from "../../pages/About";
import Admin from "../../pages/Admin";
import AdvocateWiki from "../../pages/advocate/AdvocateWiki";
import Contact from "../../pages/Contact";
import PublicMedia from "../../pages/CsaMedia/PublicMedia";
import SuperMedia from "../../pages/CsaMedia/SuperMedia";
import Events from "../../pages/Events";
import EventsInfo from "../../pages/EventsInfo";
import ForgotPassword from "../../pages/ForgotPassword";
import Home from "../../pages/home";
import EventsList from "../../pages/SuperEvents";
import Partners from "../../pages/Partners";
import ProfileEvents from "../../pages/ProfileEvents";
import skills from "../../pages/skills";
import SuperPartners from "../../pages/SuperPartners";
import SuperSchoolsWatch from "../../pages/SuperSchoolsWatch";
import SuperWiki from "../../pages/SuperWiki";
import FooterPage from "../../pages/Footer";
import PublicTestimonial from "../../pages/Testimonial/PublicTestimonial";
import SuperTestimonial from "../../pages/Testimonial/SuperTestimonial";
import PlayerUpdateInfo from "../../pages/UpdateHistory/PlayerUpdateInfo";
import SuperUpdateHistory from "../../pages/UpdateHistory/SuperUpdateHistory";
import AdvocatesList from "../athletes/AdvocatesList";
import AthleteAdminSearch from "../athletes/AthleteAdminSearch";
import AthleteDetails from "../athletes/AthleteDetails";
import AthleteEventsList from "../athletes/AthleteEventsList";
import AthleteSearch from "../athletes/AthleteSearch";
import AthleteWikis from "../athletes/AthleteWiki";
import SkillsList from "../athletes/SkillsList";
import SignIn from "../auth/SignIn";
import Navbar from "./Navbar";
import ReactGA from "react-ga";
import SuperSlideshow from "../../pages/slideshow/SuperSlideshow";
import Signup from "../../pages/signup/Signup";
import NewSignups from "../../pages/NewSignups";
import NewSignupInfo from "../../pages/NewSignupInfo";
import NewSignup from "../../pages/signup/NewSignup";
import SuperReminders from "../../pages/Reminders/SuperReminders";

ReactGA.initialize("UA-215724826-1");

const MainApp = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  });
  return (
    <>
      <Navbar />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/athletes/:id" exact component={AthleteDetails} />
        <Route path="/athletes" exact component={AthleteSearch} />
        <Route path="/events" exact component={Events} />
        <Route path="/events/:id" exact component={EventsInfo} />
        <Route path="/commitments" exact component={AthleteSearch} />
        <Route path="/contact" exact component={Contact} />
        <Route path="/about" exact component={About} />
        <Route path="/playlists" exact component={skills} />
        <Route path="/partners" exact component={Partners} />
        <Route path="/login" exact component={SignIn} />
        <Route path="/forgot-password" exact component={ForgotPassword} />
        <Route path="/admin/:id" exact component={Admin} />
        <Route path="/admin/:id/events" exact component={ProfileEvents} />
        <Route path="/admin/:id/wikis" exact component={AthleteWikis} />
        <Route path="/admin/:id/a/wikis" exact component={AdvocateWiki} />
        <Route path="/super-admin" exact component={AthleteAdminSearch} />
        <Route path="/super-admin/wiki" exact component={SuperWiki} />
        <Route path="/updatehistory" exact component={SuperUpdateHistory} />
        <Route path="/updatehistory/:id" exact component={PlayerUpdateInfo} />
        <Route path="/testimonials" exact component={PublicTestimonial} />
        <Route path="/signup" exact component={NewSignup} />
        <Route path="/new-registration/:id" exact component={Signup} />
        <Route path="/super-admin/newrequests" component={NewSignups} exact />
        <Route path="/super-admin/reminders" component={SuperReminders} exact />
        <Route
          path="/super-admin/newrequests/:id"
          component={NewSignupInfo}
          exact
        />
        <Route
          exact
          path="/super-admin/testimonials"
          component={SuperTestimonial}
        />
        <Route
          path="/super-admin/commitmentvideos"
          exact
          component={SuperSchoolsWatch}
        />
        <Route path="/super-admin/partners" exact component={SuperPartners} />
        <Route path="/super-admin/media" exact component={SuperMedia} />
        <Route path="/media" exact component={PublicMedia} />
        <Route path="/super-admin/skillslist" component={SkillsList} exact />
        <Route path="/super-admin/slideshow" component={SuperSlideshow} exact />
        <Route
          path="/super-admin/advocatelist"
          component={AdvocatesList}
          exact
        />
        <Route path="/super-admin/events" component={EventsList} exact />
        <Route path="/super-admin/:id" exact component={Admin} />
        <Route path="*" exact component={AthleteSearch} />
      </Switch>
      <FooterPage />
    </>
  );
};

export default withRouter(MainApp);
